/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { DateTimeCellModel } from "./DateTimeCellModel";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
import { markType } from "igniteui-react-core";
import { stringEmpty } from "igniteui-react-core";
/**
 * @hidden
 */
var DateTimeCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DateTimeCellPresenter, _super);
    function DateTimeCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(DateTimeCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    DateTimeCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            if (a.aw(DateTimeCellModel.ko) || a.aw(DateTimeCellModel.kp) || a.aw(DateTimeCellModel.kn)) {
                this.e(b);
                this.d.b4.setRawText(b.ie);
            }
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.b4, this.a);
        }
    };
    DateTimeCellPresenter.prototype.e = function (a) {
        a.ie = a.kx(a.km);
        if (a.ie == stringEmpty() && a.gh != null) {
            a.ie = a.gh.toString();
        }
    };
    DateTimeCellPresenter.$t = markType(DateTimeCellPresenter, 'DateTimeCellPresenter', CellPresenterBase.$);
    return DateTimeCellPresenter;
}(CellPresenterBase));
export { DateTimeCellPresenter };
//# sourceMappingURL=DateTimeCellPresenter.js.map
